import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Stack,
  Typography,
} from "@mui/material";
import CloseRounded from "@mui/icons-material/CloseRounded";
import LockRounded from "@mui/icons-material/LockRounded";
import CoverageAnalysis from "./CoverageAnalysis";
export default function CoverageDock({ analysis }) {
  const [open, setOpen] = useState(false);
  const { state, retry } = analysis;
  const running = ["uploading", "running"].includes(state.status);
  const colored = state.result?.colored;
  const percent = state.result?.coveragePercent?.toLocaleString("pt-BR", {
    maximumFractionDigits: 4,
  });
  return (
    <>
      <Box
        component="aside"
        aria-label="Análise de cobertura em segundo plano"
        sx={{
          position: "fixed",
          bottom: 16,
          left: { xs: 16, xl: 294 },
          right: 16,
          zIndex: 1100,
          bgcolor: "#fff",
          border: "1px solid #ccddd2",
          borderRadius: 3,
          boxShadow: "0 8px 32px #183d2526",
          overflow: "hidden",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          gap={2}
          sx={{ p: { xs: 1.5, sm: 2 } }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="subtitle2"
              sx={{ color: "#182d27", display: "flex", alignItems: "center", gap: 0.75 }}
            >
              {colored && <LockRounded sx={{ fontSize: 17 }} />}
              {running
                ? "Analisando cobertura do miolo"
                : state.status === "error"
                ? "Análise do miolo interrompida"
                : colored
                ? "Miolo colorido · classificação bloqueada"
                : "Análise do miolo concluída"}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block" mt={0.5}>
              {state.status === "uploading"
                ? "Enviando PDF. Continue preparando sua publicação."
                : state.status === "running"
                ? `Página ${state.page || 1}${
                    state.total ? ` de ${state.total}` : ""
                  }. Você pode avançar nas etapas.`
                : state.status === "error"
                ? "Tente novamente para liberar a publicação."
                : `Cobertura: ${percent}% · limite: ${
                    state.result?.rules?.colorCoveragePercent ??
                    state.rules?.colorCoveragePercent ??
                    "—"
                  }%${
                    colored
                      ? ". A seleção de preto e branco foi bloqueada."
                      : ". Confira a configuração de impressão."
                  }`}
            </Typography>
          </Box>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            gap={0.5}
            sx={{ flexShrink: 0, "& button": { minHeight: 44, borderRadius: 2 } }}
          >
            {state.status === "error" && (
              <Button color="success" onClick={retry}>
                Tentar novamente
              </Button>
            )}
            <Button variant="outlined" color="success" onClick={() => setOpen(true)}>
              Detalhes
            </Button>
          </Stack>
        </Stack>
        {running && (
          <LinearProgress
            aria-label="Progresso da análise em segundo plano"
            variant={state.total ? "determinate" : "indeterminate"}
            value={state.total ? Math.max(0, ((state.page - 1) / state.total) * 100) : 0}
          />
        )}
      </Box>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="lg"
        aria-labelledby="coverage-details-title"
        PaperProps={{ sx: { borderRadius: 3 } }}
      >
        <DialogTitle
          id="coverage-details-title"
          sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          Análise do miolo
          <IconButton aria-label="Fechar detalhes da análise" onClick={() => setOpen(false)}>
            <CloseRounded />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <CoverageAnalysis analysis={analysis} />
        </DialogContent>
      </Dialog>
    </>
  );
}
